export default __webpack_public_path__ + "static/media/Calendar_Icon.e4384dcd.svg";